import React from 'react';
import { Calendar } from 'lucide-react';

interface StoryDateProps {
  date: string;
}

export function StoryDate({ date }: StoryDateProps) {
  return (
    <div className="flex items-center gap-2 body-small text-accessible-gray-600 dark:text-white/90 high-contrast:text-white no-margin">
      <Calendar className="w-4 h-4" aria-hidden="true" />
      <span>{date}</span>
    </div>
  );
}